// extracted by mini-css-extract-plugin
export var component = "CalendarBadge-module--component--1Js3L";
export var day = "CalendarBadge-module--day--qja24";
export var month = "CalendarBadge-module--month--HhA8k";